import { usePortalQuery } from "@/state/hooks/usePortalQuery";
import { queryKeys } from "@/state/queryKeys";
import trpc from "@/shared/utils/trpc";

export type GuestNetworkWhoAmIStat = {
  key: string;
  label: string;
  count: number;
  percent: number;
  percentLabel: string;
};

export type GuestNetworkIndustryStat = {
  key: string;
  label: string;
  count: number;
};

export type GuestNetworkRegionStat = {
  key: string;
  label: string;
  count: number;
  percent: number;
  percentLabel: string;
};

export type GuestNetworkStats = {
  totalCompanies: number;
  continentsCovered: number;
  totalCountries: number;
  whoAmI: GuestNetworkWhoAmIStat[];
  industries: GuestNetworkIndustryStat[];
  regions: GuestNetworkRegionStat[];
};

/** Shared Query cache for guest + auth Discover hero stats (all explore tabs). */
export function useGuestNetworkStats(enabled: boolean) {
  const q = usePortalQuery({
    queryKey: queryKeys.discover.networkStats(),
    queryFn: () => trpc.discover.getGuestNetworkStats.query(),
    enabled,
    staleTime: 5 * 60_000,
  });

  return {
    stats: q.data ?? null,
    loading: q.isInitialLoading,
    loadError: q.isError,
  };
}

export function formatMarketingCount(n: number): string {
  if (n >= 1000) return `${Math.floor(n / 100) * 100}+`;
  return n.toLocaleString();
}

export const GUEST_NETWORK_STATS_UNAVAILABLE = "Unable to load these stats right now.";
export const GUEST_NETWORK_STATS_EMPTY = "No stats to display yet.";
